module.exports = __webpack_public_path__ + "img/42000.f8dba48b.jpg";